import { render, staticRenderFns } from "./call-request-babyloan.pug?vue&type=template&id=70503c0d&lang=pug&"
import script from "./call-request-babyloan.js?vue&type=script&lang=js&"
export * from "./call-request-babyloan.js?vue&type=script&lang=js&"
import style0 from "../../../common/css/call-request.scss?vue&type=style&index=0&prod&lang=globalCss&"
import style1 from "../../../common/css/vendors.scss?vue&type=style&index=1&prod&lang=globalCss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports